import dotenv from "dotenv"
dotenv.config({ path: ("../../.env") })
const apiURL = process.env.REACT_APP_API_URL
const uri = `http://52.54.195.156:3000/api/v1/jobs`;

const remotionExtraction = process.env.REACT_APP_REMOTION_BUNDLER_URL || "https://remotion-bundler.buzzle.site/"
export const ServerJobs = {
  getAll: async () => {
    const response = await fetch(uri, {
      headers: { "nexrender-secret": "myapisecret" },
    });
    if (response.ok) {
      return await response
        .json()
        .then((v) =>
          //@ts-ignore
          v.sort((a, b) => new Date(b?.updatedAt) - new Date(a?.updatedAt))
        );
    } else {
      throw new Error(
        "Wrong or no authentication secret provided. Please check the nexrender-secret header."
      );
    }
  },
  get: async (id: string) => {
    const response = await fetch(`${uri}/${id}`, {
      headers: { "nexrender-secret": "myapisecret" },
    });
    return await response.json();
  },
  delete: async (id: string) => {
    await fetch(`${uri}/${id}`, {
      method: "DELETE",
      headers: { "nexrender-secret": "myapisecret" },
    });
    return true;
  },
  deleteAll: async (idArray = []) => {
    await Promise.all(
      idArray.map((id) =>
        fetch(`${uri}/${id}`, {
          method: "DELETE",
          headers: { "nexrender-secret": "myapisecret" },
        })
      )
    );
    return true;
  },
};
export const getCountry = async () => {
  const result = await fetch('http://ip-api.com/json');
  const code = (await result.json())?.countryCode;
  return code;
};
export const getExtractionServerIP = async (type: "ae" | "remotion") => {
  const aeExtraction = process.env.REACT_APP_AE_EXTRACT_URL || "https://buzzle-extraction-service-6cjz5.ondigitalocean.app"
  if (type === 'ae') {
    if (aeExtraction) {
      const result = await fetch(`${aeExtraction}/status`)
      if (result.ok) {
        return aeExtraction
      } else {
        throw new Error("Error Server Status Not Ok")
      }
    }
    throw new Error("No Extraction Server Found")
  } else {
    const result = await fetch(`${remotionExtraction}`)
    if (result.ok) {
      return remotionExtraction
    }
    else {
      throw new Error("Error!")
    }
  }
}
function random(mn: number, mx: number) {
  return Math.random() * (mx - mn) + mn;
}
const isIpHaveExtractionServerRunning = async (ip: string) => {
  try {
    return (await fetch(`http://${ip}`)).ok
  } catch (err) {
    return false
  }

}
const getIPWhichRunningExtractionServer = async (ipList: Array<string>) => {
  const runningIp: Array<string> = []
  await Promise.all(ipList?.map(async (ip) => {
    if (await isIpHaveExtractionServerRunning(ip)) {
      runningIp.push(ip)
      return true
    } else {
      return false
    }
  }))
  return runningIp
}
// // export const {
// //   Job,
// //   User,
// //   VideoTemplate,
// //   Font,
// //   Search,
// //   Auth,
// //   Webhook,
// //   Creator,
// // } = API;

